import type { Plugin } from "svelte-exmarkdown";
import { visit } from "unist-util-visit";

/*
 * This plugin is used to preserve the alt text of images as markdown source.
 * Later used in `GlossaryImage.svelte` to render the image using the alt text
 * as <figcaption>.
 */
export const preserveAltMdPlugin: Plugin = {
  remarkPlugin: () => (tree, file) => {
    const contents = file.value as string;

    visit(tree, "image", (node) => {
      if (!node.position) return;

      const { start, end } = node.position;

      const markdownSegment = contents.slice(start.offset, end.offset);
      const match = markdownSegment.match(/^!\[(.*)\]\((.*)\)/);
      if (match) {
        node.alt = match[1];
      }
    });
  },
};
